import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { regionModel } from '~/entities/common/Taxipark/Regions'
import {
  EditRegion,
  editRegionModal,
} from '~/features/common/Taxipark/Regions/EditRegion'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import { NotFound } from '~/shared/ui/NotFound'

export const EditRegionPage = () => {
  const { t } = useTranslation()
  const { regionId } = useParams<{ regionId: string }>()

  const isLoading = useStore(regionModel.requestFx.pending)
  const regionName = useStoreMap(editRegionModal.$region, (employee) =>
    employee?.getName(),
  )

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { titleI18n: 'regions', link: '/taxipark/regions' },
      { title: regionName || '' },
    ],
    [regionName],
  )

  const error = regionModel.useRegionError(regionId as string)

  if (!regionId || error) {
    return <NotFound message={t('alert.failed to load region')} />
  }

  return (
    <PageContainer title={t('region card')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <PageTitle loading={isLoading}>{regionName}</PageTitle>
      </Container>

      <EditRegion regionId={regionId} />
    </PageContainer>
  )
}
